module.exports = __webpack_public_path__ + "static/banner-3-b877f49a0de4b2641604339655b6d931.jpg";